// extracted by mini-css-extract-plugin
module.exports = {"container":"MobilePageContainer_container__3Gado","hasDefaultHeader":"MobilePageContainer_hasDefaultHeader__2_nhF","background":"MobilePageContainer_background__CjBKk"};